<div class="container">
  <aside>
    <app-card
      [title]="dictionary.get('Visits')"
      icon="iconoirOpenInWindow"
      [info]="totalVisits() + ' ' + dictionary.get('Visits')"
      [accordionContent]="visitsDetails()"
      [loading]="isLoadingVisits()"
      [hasError]="hasVisitsError()"
      [errorMessage]="dictionary.get('FailedToLoadData')"
      [retryButtonText]="dictionary.get('Retry')"
      (onRetry)="retryLoadVisits()"
    ></app-card>

    <app-card
      [title]="dictionary.get('CallsDuration')"
      icon="iconoirPhone"
      [info]="avgCallDuration() + ' ' + dictionary.get('Minutes')"
      [loading]="isLoadingVisits()"
      [hasError]="hasVisitsError()"
      [errorMessage]="dictionary.get('FailedToLoadData')"
      [retryButtonText]="dictionary.get('Retry')"
      (onRetry)="retryLoadVisits()"
    ></app-card>

    <app-card [title]="dictionary.get('Snapshot')" icon="iconoirDatabaseScript">
      <app-select
        (getSelectedOption)="setReportType($event)"
        [options]="reports"
        [isFullWidth]="true"
        class="w-100"
        [placeholder]="dictionary.get('SelectValue')"
      ></app-select>

      <button
        buttonTheme="primary"
        buttonType="regular"
        [loading]="isDownloadingReport"
        class="w-100 mt-2"
        (click)="onExportClick()"
        [disabled]="!selectedReport || isDownloadingReport"
      >
        {{
          isDownloadingReport
            ? dictionary.get('Downloading')
            : dictionary.get('Download')
        }}
      </button>
    </app-card>
  </aside>
  <main>
    <app-tabs>
      <app-sales></app-sales>
      <app-products></app-products>
      <app-supervisors></app-supervisors>
    </app-tabs>
  </main>
</div>
